import { render, staticRenderFns } from "./ErrorReviewQuestion.vue?vue&type=template&id=7b0c8130"
import script from "./ErrorReviewQuestion.vue?vue&type=script&lang=js"
export * from "./ErrorReviewQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports